import React from "react";
import {
  BrowserRouter as Router,
  RouteComponentProps,
  Switch,
} from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import { defaultTheme } from "./themes";
import AuthProvider from "./components/AuthProvider";
import CityConfigProvider from "./components/CityConfigProvider";
import CommonConfigProvider from "./components/CommonConfigProvider";
import ControlReviewProvider from "./components/ControlReviewProvider";
import EnhancedIntlProvider from "./components/EnhancedIntlProvider";
import EnhancedThemeProvider from "./components/EnhancedThemeProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import FpsProvider from "./components/FpsProvider";
import ImageReview from "./components/ImageReview";
import Layout from "./components/Layout";
import LightLogin from "./components/LightLogin";
import Login from "./components/Login";
import MomentLocaleSetup from "./components/MomentLocaleSetup";
import PageNotFound from "./components/PageNotFound";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import TicketProvider from "./components/TicketProvider";
import YupLocaleSetup from "./components/YupLocaleSetup";

const ImageReviewPage = () => (
  <Layout hideDrawer hideLocaleSwitcher>
    <ErrorBoundary>
      <CityConfigProvider>
        <CommonConfigProvider>
          <ControlReviewProvider>
            <TicketProvider>
              <FpsProvider>
                <ImageReview />
              </FpsProvider>
            </TicketProvider>
          </ControlReviewProvider>
        </CommonConfigProvider>
      </CityConfigProvider>
      <LightLogin />
    </ErrorBoundary>
  </Layout>
);

const LoginPage = (props: RouteComponentProps) => (
  <Layout hideDrawer hideLocaleSwitcher>
    <ErrorBoundary>
      <Login {...props} />
    </ErrorBoundary>
  </Layout>
);

const PageNotFoundPage = (props: RouteComponentProps) => (
  <Layout hideLocaleSwitcher>
    <PageNotFound {...props} />
  </Layout>
);

function App() {
  return (
    <ErrorBoundary>
      <CssBaseline />
      <EnhancedIntlProvider>
        <MomentLocaleSetup />
        <YupLocaleSetup />
        <EnhancedThemeProvider themeOptions={defaultTheme}>
          <ErrorBoundary>
            <AuthProvider checkTokenValidityDelay={10000}>
              <Router>
                <Switch>
                  <PrivateRoute exact path="/" component={ImageReviewPage} />
                  <PublicRoute
                    exact
                    restricted
                    path="/login"
                    component={LoginPage}
                  />
                  <PublicRoute component={PageNotFoundPage} />
                </Switch>
              </Router>
            </AuthProvider>
          </ErrorBoundary>
        </EnhancedThemeProvider>
      </EnhancedIntlProvider>
    </ErrorBoundary>
  );
}

export default App;
